import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getMemberById } from "../../../../../api/apiServices";
import { useQuery } from "react-query";
import MemberView from "./RegionalMemberView";
import MemberCardLeft from "./RegionalMemberCardLeft";
import MemberCardRight from "./RegionalMemberCardRight";

const DisplayRegionalMember = () => {
	const params = useParams();
	const id = parseInt(params.id);

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/regional_members";

	const {
		isLoading,
		error,
		data: memberDetails,
	} = useQuery(["memberDetails", id], () => getMemberById(id));

	console.log(memberDetails);
	// const member = memberDetails

	// let fullname = member[0]?.title + " " + member[0]?.first_name + " " + member[0]?.middle_name + " " + member[0]?.last_name

	let content;
	if (isLoading) {
		content = <p>Loading Member Details...</p>;
	} else if (error) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<>
				<MemberView>
					<MemberCardLeft
						fullname={
							memberDetails?.title +
							" " +
							memberDetails?.first_name +
							" " +
							memberDetails?.middle_name +
							" " +
							memberDetails?.last_name
						}
						imageUrl={`/images/members/${memberDetails?.profile_picture}`}
						pf_number={memberDetails?.pf_number}
					/>
					<MemberCardRight member={memberDetails} />
				</MemberView>
			</>
		);
	}
	const handleCancel = () => {
		navigate(from, { replace: true });
	};

	return (
		<>
			<section className="content-header">
				<h1>Member Information </h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>
												Detailed Member Information
											</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
							<div className="panel-footer">
								<div className="row">
									<div className="col-sm-2">
										<button
											type="button"
											className="btn btn-danger btn-block "
											onClick={handleCancel}
										>
											{" "}
											<i className="fa fa-close"></i> EXIT
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
};

export default DisplayRegionalMember;
